<template>
  <section
    class="flex justify-center p-8 py-24 rounded whitespace-nowrap bg-background"
  >
    Check inbox for confirmation email
  </section>
</template>
